import React, {FC} from 'react';

import {useAppSelector} from 'store/config/hooks';
import {selectModalData, TModalComponentInterface} from 'store/slices/modals-slice';

import {ListModal} from './list-modal';

export const ListModalContainer: FC<TModalComponentInterface> = ({
    onClose,
}: TModalComponentInterface) => {
    const entityName = useAppSelector(state => selectModalData(state)?.entityName) || '';
    return (
        <ListModal
            entityName={entityName}
            onClose={onClose}
        />
    );
};
